import React, {useState} from "react";
import BreadcrumbExtend from "../../../components/BreadcrumbExtend";
import {withNamespaces} from "react-i18next";
import {history} from "../../../helpers/history";
const ImportsPage = ({t}) => {
    const breadcrumb = [{ value: 'imports', path: '#' }];
    return (
        <div>
            <BreadcrumbExtend items={breadcrumb}/>
            <div className="row">
                <h4 className="col-md-6">{t('imports')}</h4>
            </div>
            <div className="card">
                <div className="card-body">
                    <div className={"row"}>
                        <div className={"col-md-4"}>
                            <div className="small-box bg-info" onClick={() => history.push("/panel/import/network-device")}>
                                <div className="inner">
                                    <h3>{t('import')}</h3>
                                    <span className="info-box-text">{t('network-devices')}</span>
                                </div>
                                <div className="icon">
                                    <i className="fa fa-download"></i>
                                </div>
                                <div className="small-box-footer">
                                    {t("click-to-import")}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default withNamespaces()(ImportsPage);